import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { AIDES_PROFESSIONNELS } from '../../../../config/aides-professionnels';

export default function CoupDePouceCvcPage() {
  const aide = AIDES_PROFESSIONNELS.find((a) => a.slug === 'coup-de-pouce-cvc');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="professionnels" />;
}
